import { useRouter } from 'vue-router'
import api from '@/servicios/apiCliente'
import { useStore } from '../../../store'

export function useLogout() {
  const store = useStore()
  const router = useRouter()

  async function salir() {
    await api.Cliente.Cliente.HomeApi.Logout()
    store.sesionIniciada = false
    await router.push({ name: 'cliente-cliente-login' })
    window.sessionStorage.clear()
    window.location.reload()
  }

  return { salir }
}
